import {
  CompaniesInfiniteSelectField,
  InputDate,
  InputDecimal,
} from '@/components/_common';
import { PurchaseListParams } from '@/core/domain/purchase/Purchase.types';
import { ExtraFiltersProps } from '@/types/ExtraFiltersProps';
import { Status } from '@/utils/enum/statusEnum';
import { Col, Input, Row, Select } from 'antd';
import moment from 'moment';

import { useIntl } from 'react-intl';

const PurchasesExtraFilters: React.FC<
  ExtraFiltersProps<PurchaseListParams>
> = ({ queryParams, setQueryParams }) => {
  const intl = useIntl();

  return (
    <Row gutter={[16, 16]}>
      <Col span={24} md={12} lg={8} xxl={6}>
        <Input
          value={queryParams?.workOrderNumber}
          onChange={({ target }) =>
            setQueryParams((prev) => ({
              ...prev,
              workOrderNumber: target.value,
            }))
          }
          placeholder={intl.formatMessage({
            id: 'purchases.filters.workerOrderNumber',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={6}>
        <CompaniesInfiniteSelectField
          onChange={(values) => {
            setQueryParams((prev) => ({ ...prev, companyId: values }));
          }}
          value={queryParams?.companyId}
          placeholder={intl.formatMessage({
            id: 'purchases.filters.company',
          })}
          allowClear
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={6}>
        <Input
          value={queryParams?.supplier}
          onChange={({ target }) =>
            setQueryParams((prev) => ({
              ...prev,
              supplier: target.value,
            }))
          }
          placeholder={intl.formatMessage({
            id: 'purchases.filters.supplier',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={6}>
        <Input
          value={queryParams?.documentNumber}
          onChange={({ target }) =>
            setQueryParams((prev) => ({
              ...prev,
              documentNumber: target.value,
            }))
          }
          placeholder={intl.formatMessage({
            id: 'purchases.filters.documentNumber',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={6}>
        <InputDate
          value={
            queryParams?.releaseDate
              ? moment(queryParams?.releaseDate)
              : undefined
          }
          onChange={(releaseDate) =>
            setQueryParams((prev) => ({
              ...prev,
              releaseDate: releaseDate?.toISOString(),
            }))
          }
          placeholder={intl.formatMessage({
            id: 'purchases.filters.releaseDate',
          })}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={6}>
        <Select
          mode="multiple"
          allowClear
          style={{ width: '100%' }}
          placeholder={intl.formatMessage({
            id: 'purchases.filters.situation',
          })}
          value={queryParams?.situations}
          onChange={(situations) =>
            setQueryParams((prev) => ({
              ...prev,
              situations,
            }))
          }
          options={[
            {
              value: Status.open,
              label: intl.formatMessage({
                id: 'purchases.situation.OPEN',
              }),
            },
            {
              value: Status.authorized,
              label: intl.formatMessage({
                id: 'purchases.situation.AUTHORIZED',
              }),
            },
            {
              value: Status.canceled,
              label: intl.formatMessage({
                id: 'purchases.situation.CANCELED',
              }),
            },
          ]}
        />
      </Col>

      <Col span={24} md={12} lg={8} xxl={6}>
        <Select
          value={queryParams?.isGrouping}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              isGrouping: value as unknown as boolean,
            }))
          }
          placeholder="Filtrar por agrupamento"
          allowClear
          style={{ width: '100%' }}
          options={[
            { label: 'Compras agrupadas', value: 'true' },
            { label: 'Compras não agrupadas', value: 'false' },
          ]}
        />
      </Col>

      <Col xs={24} sm={24} lg={3} md={12}>
        <InputDecimal
          value={queryParams?.totalAmount}
          onChange={(value) =>
            setQueryParams((prev) => ({
              ...prev,
              totalAmount: value,
            }))
          }
          placeholder="Valor total"
        />
      </Col>
    </Row>
  );
};

export default PurchasesExtraFilters;
